/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntentRequest } from "./PartnerIntentRequest";

export interface CreateEligibilityConversationRequest {
  initial_message: string;
  partner_intent?: PartnerIntentRequest | null;
}
